
export enum MarketRegionEnum {
    Africa = 1,
    CentralAmerica = 2,
    EastAsia = 3,
    EuropeEU = 4,
    EuropeNonEU = 5,
    MiddleEast = 6,
    NorthAmerica = 7,
    Oceania = 8,
    SouthAmerica = 9,
    SouthAsia = 10,
    SouthEastAsia = 11,
    CentralAsia = 12,
    Caribbean = 13,
}

// 1:1 z Display(Name=...)
export const MARKET_REGION_LABEL: Record<MarketRegionEnum, string> = {
    [MarketRegionEnum.Africa]: "Africa",
    [MarketRegionEnum.CentralAmerica]: "Central America (e.g. Mexico)",
    [MarketRegionEnum.EastAsia]: "East Asia (e.g. China, Japan, Korea)",
    [MarketRegionEnum.EuropeEU]: "Europe - EU countries",
    [MarketRegionEnum.EuropeNonEU]: "Europe - non EU (e.g. UK, Russia, ex-CIS countries)",
    [MarketRegionEnum.MiddleEast]: "Middle East Region (e.g. UAE)",
    [MarketRegionEnum.NorthAmerica]: "North America (USA, Canada)",
    [MarketRegionEnum.Oceania]: "Oceania",
    [MarketRegionEnum.SouthAmerica]: "South America (e.g. Brazil, Colombia)",
    [MarketRegionEnum.SouthAsia]: "South Asia (e.g. India, Pakistan, Sri Lanka)",
    [MarketRegionEnum.SouthEastAsia]: "South East Asia (e.g. Thailand, Philippines, Singapore)",
    [MarketRegionEnum.CentralAsia]: "Central Asia (e.g. Kazakhstan, Uzbekistan)",
    [MarketRegionEnum.Caribbean]: "Caribbean (e.g. Dominican Republic, Jamaica)",
} as const;

export const marketRegionLabel = (
    v?: number | MarketRegionEnum | null
): string => (v ? MARKET_REGION_LABEL[v as MarketRegionEnum] ?? "—" : "—");

export const normalizeRegionId = (
    v: number | string
): MarketRegionEnum | undefined => {
    if (typeof v === "number") return v as MarketRegionEnum;
    // TS numeric enum ma reverse mapping: MarketRegionEnum["Africa"] -> 1
    const id = (MarketRegionEnum as any)[v];
    return typeof id === "number" ? (id as MarketRegionEnum) : undefined;
};

export const MARKET_REGIONS: ReadonlyArray<{
    value: MarketRegionEnum;
    label: string;
}> = (Object.values(MarketRegionEnum) as Array<string | number>)
    .filter((v): v is number => typeof v === "number")
    .map((value) => ({ value, label: MARKET_REGION_LABEL[value as MarketRegionEnum] }));

export type MarketRegionName = keyof typeof MarketRegionEnum;

export const MARKET_REGIONS_BY_NAME: ReadonlyArray<{
    value: MarketRegionName; // np. "Africa"
    label: string;
}> = (Object.values(MarketRegionEnum)
    .filter((v): v is MarketRegionName => typeof v === "string"))
    .map((name) => ({
        value: name,
        label: MARKET_REGION_LABEL[(MarketRegionEnum as any)[name] as MarketRegionEnum],
    }));

export const toRegionId = (v: number | string): MarketRegionEnum | undefined => {
    if (typeof v === "number") return v as MarketRegionEnum;
    const id = (MarketRegionEnum as any)[v];
    return typeof id === "number" ? (id as MarketRegionEnum) : undefined;
};

export const toRegionName = (v: number | string): MarketRegionName | undefined => {
    if (typeof v === "string") return v as MarketRegionName;
    return (MarketRegionEnum as any)[v] as MarketRegionName | undefined;
};